"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhoneNumber = void 0;
/**
 * formatting phone numbers in a set of group of first 4 digits and Group remaining digits in
 * sets of three like '1800319750' => '1800 319 750'
 */
const formatPhoneNumber = (phoneNumber) => {
    const numberPattern = phoneNumber.match(/^(\d{4})(\d{3})(\d*)$/);
    if (numberPattern) {
        const { 1: firstGroup, 2: secondGroup, 3: remainingDigits } = numberPattern;
        const formattedNumber = [firstGroup, secondGroup].join(" ");
        if (remainingDigits) {
            const remainingFormatted = remainingDigits.match(/\d{1,3}/g).join(" ");
            return `${formattedNumber} ${remainingFormatted}`;
        }
        return formattedNumber;
    }
    return phoneNumber;
};
exports.formatPhoneNumber = formatPhoneNumber;
//# sourceMappingURL=formatPhoneNumber.js.map